import { ControlLabel, FormGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';
import React from 'react';

import './ConversionDisplay.css';

function HeightDisplay(_ref, _ref2) {
  var name = _ref.name,
      label = _ref.label;
  var form = _ref2.form;

  var converted = React.createElement(
    'p',
    { className: 'HW-Display' },
    'Please enter your height in inches'
  );

  var height = Number(form.get(name));
  if (height > 0) {
    var heightCm = Math.floor(2.54 * height);
    var heightFt = Math.floor(height / 12);
    var heightIn = Math.floor(height - 12 * heightFt);

    converted = React.createElement(
      'p',
      { className: 'HW-Display' },
      React.createElement(
        'strong',
        null,
        heightFt,
        '\' ',
        heightIn,
        '" or ',
        heightCm,
        ' cm'
      )
    );
  }

  return React.createElement(
    FormGroup,
    null,
    label && React.createElement(
      ControlLabel,
      null,
      label
    ),
    converted
  );
}

HeightDisplay.contextTypes = {
  form: PropTypes.object.isRequired
};

HeightDisplay.propTypes = process.env.NODE_ENV !== "production" ? {
  label: PropTypes.string,
  name: PropTypes.string.isRequired
} : {};

export default HeightDisplay;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-form-builder/es/Fields/HeightDisplay.js
// module id = 702
// module chunks = 0